import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const knowledgeHubSearchRoute: InvariantJiraRoute = {
	name: 'knowledge-hub-search',
	path: '/jira/servicedesk/projects/:projectKey/knowledge/search/articles/:articleId',
};
